// on menu classs toggle
document.querySelector(".text-with-icon").addEventListener("click", () => {
  document
    .querySelector(".text-with-icon")
    .classList.toggle("menu-icon-rotate");
});

// tabs on Desktop
if (window.innerWidth > 800) {
  function openTab(evt, tabName) {
    let i, upliftTabcontent, upliftTablinks;

    upliftTabcontent = document.querySelectorAll(
      ".uplift-desktop-tabs .uplift-tabcontent"
    );
    for (i = 0; i < upliftTabcontent.length; i++) {
      upliftTabcontent[i].style.display = "none";
    }
    upliftTablinks = document.getElementsByClassName("uplift-tablinks");
    for (i = 0; i < upliftTablinks.length; i++) {
      upliftTablinks[i].className = upliftTablinks[i].className.replace(
        " active",
        ""
      );
    }

    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
  }
  document.getElementById("defaultOpen").click();
}

// tabs slider on mobile
document.addEventListener("DOMContentLoaded", function () {
  let swiper = new Swiper("#swiper-slider", {
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
});
